import * as React from "react";
import { useParams } from "react-router-dom";
import {
  // useViewCategoryOffers,
  ViewCategoryPWA,
  useFindAllLocations,
  useMyIdentities,
  MyAppSettingController,
  SearchOffersByCategory
} from "@njoy/controller";
import { useRef } from "react";
import { OfferCountdownCard } from "../../../components/cards/OfferCountdownCard";
import searchIcon from "../../../assets/discovery/search-icon.png";
import filterLocationIcon from "../../../assets/discovery/filter-horizontal.png";
import SearchInput from "../../../components/uiMerge/searchInput";
import OfferCardSkeleton from "../../../components/cards/OfferCardSkeleton";
import NoticeBox from "../../../components/noticeBox/NoticeBox";
import { TemplateSub } from "../../../components/layouts/TemplateSub";
import Button from "../../../components/uiMerge/newButton";
import { LocationFilterModal } from "../../../components/modals/locationFilterModal";
import PageLoader from "src/modules/shared/PageLoader";

export const FindOfferCategoriesConnector: React.FC = () => {
  const loadMoreRef = useRef<HTMLDivElement>(null);
  const { categoryId } = useParams<{ categoryId: string }>();
  // Remove global countdown, use per-offer countdown if needed
  const [searchTerm, setSearchTerm] = React.useState("");
  const [openLocationFilter, setOpenLocationFilter] = React.useState(false);
  const [filterByType, setFilterByType] = React.useState<string>("");
  const [filterByCommunity, setFilterByCommunity] = React.useState<string>("");
  const [filterByLocationId, setFilterByLocationId] = React.useState<string>("");
  const [endingSoon, setEndingSoon] = React.useState<boolean>(false);
  const [isLoadingMore, setIsLoadingMore] = React.useState(false);

  // const { categoryOffers = [], } = useViewCategoryOffers({
  //   categoryId: categoryId ?? "",
  //   limit: 10,
  //   offset: 0,
  // });

  const { myIdentities } = useMyIdentities({
    offset: 0,
    limit: 10, // or any page size you want
  });

  const { locations, loading: locationLoading } = useFindAllLocations();

  const resetLocationFilter = () => {
    setSearchTerm("");
    setFilterByType("");
    setFilterByLocationId("");
    setEndingSoon(false);
    setFilterByCommunity("");
  };


  // Filter offers by search term
  // const filteredOffers = categoryOffers.filter((offer) => {
  //   const matchesSearch =
  //     searchTerm.trim().length === 0 ||
  //     offer.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     (offer.description &&
  //       offer.description.toLowerCase().includes(searchTerm.toLowerCase()));
  //   return matchesSearch;
  // });

  return (
    <MyAppSettingController>
      {({ data, loading }) => {
        if (loading) {
          return (
            <PageLoader />
          );
        }

        const currentLocationId = data?.myAppSetting?.location?.id || "";

        return (
          <ViewCategoryPWA categoryId={categoryId ?? ""}>
            {({ category }) => (
              <TemplateSub page={category?.name}>
                <div className="w-full flex-1 h-full px-[1rem] pb-10">
                  <div className="flex justify-between items-center ">
                    <SearchInput
                      prefixIcon={
                        <img
                          src={searchIcon}
                          alt="search"
                          width={20}
                          height={20}
                        />
                      }
                      onClick={() => { }}
                      id="search"
                      name="search"
                      type="search"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      end2end={true}
                      className=" max-[415px]:w-[320px] max-[390px]:w-[300px] max-[376px]:w-[295px] max-[361px]:w-[220px] max-[435px]:w-[340px] w-[360px] h-11 flex items-center gap-3 mt-0"
                    />

                    <div
                      className="flex items-center justify-center cursor-pointer w-11 h-11 rounded-md bg-[#404040] mt-1"
                      onClick={() => setOpenLocationFilter(true)}
                    >
                      <img
                        src={filterLocationIcon}
                        alt=""
                        height={20}
                        width={20}
                        className="cursor-pointer"
                      />
                    </div>
                  </div>

                  <SearchOffersByCategory
                    variables={{
                      input: {
                        categoryId: categoryId || "",
                        searchText: searchTerm,
                        filterByType,
                        filterByCommunity,
                        filterByLocationId:
                          filterByLocationId === ""
                            ? currentLocationId
                            : filterByLocationId,
                        endingSoon,
                      },
                      offset: 0,
                      limit: 10,
                    }}
                  >
                    {({ offers: searchOffersByCategory, loading: searchOfferByCategoryLoading, loadMore, hasMoreOffers }) => {
                      return (
                        <div className="w-full mt-5">
                          {searchOfferByCategoryLoading ? (
                            <div className="flex flex-wrap gap-[24px]">
                              <div className="max-w-[222px]"><OfferCardSkeleton /></div>
                              <div className="max-w-[222px]"><OfferCardSkeleton /></div>
                              <div className="max-w-[222px]"><OfferCardSkeleton /></div>
                            </div>
                          )
                            // : (!filteredOffers.length) ? (
                            //   <div className="grid gap-4">
                            //     <NoticeBox
                            //       message="No offers available for this category at the moment"
                            //       noLeftMargin
                            //     />
                            //   </div>
                            // )
                            : (
                              // filteredOffers.length && 
                              !searchOffersByCategory.length
                            ) ? (
                              <div className="grid gap-4">
                                <NoticeBox
                                  message="No offers available for this location at the moment"
                                  noLeftMargin
                                />
                              </div>
                            ) : (
                              <div ref={loadMoreRef} className="grid grid-cols-2 gap-4">
                                {searchOffersByCategory.map((c) => (
                                  <div key={c.id} data-offer-card>
                                    <OfferCountdownCard offer={c} />
                                  </div>
                                ))}
                              </div>
                            )}

                          {hasMoreOffers && (
                            <div className="flex justify-center mt-5">
                              <Button
                                className="bg-blue-600 mb-10 text-white !text-[14px] px-3 py-1 rounded"
                                onClick={async () => {
                                  setIsLoadingMore(true);
                                  const previousCount = searchOffersByCategory.length;
                                  await loadMore();
                                  setIsLoadingMore(false);

                                  const pollForNewItems = () => {
                                    const currentItems = loadMoreRef.current?.parentElement?.querySelectorAll('[data-offer-card]');
                                    if (currentItems && currentItems.length > previousCount && !isLoadingMore) {
                                      requestAnimationFrame(() => {
                                        requestAnimationFrame(() => {
                                          loadMoreRef.current?.scrollIntoView({
                                            behavior: "smooth",
                                            block: "end",
                                          });
                                        });
                                      });
                                    } else {
                                      setTimeout(pollForNewItems, 50);
                                    }
                                  };
                                  pollForNewItems();
                                }}
                                disabled={searchOfferByCategoryLoading}
                              >
                                Load More
                              </Button>
                            </div>
                          )}
                        </div>
                      );
                    }}
                  </SearchOffersByCategory>
                </div>

                <LocationFilterModal
                  isOpen={openLocationFilter}
                  setIsOpen={setOpenLocationFilter}
                  onClose={() => setOpenLocationFilter(false)}
                  setFilterByType={setFilterByType}
                  setFilterByCommunity={setFilterByCommunity}
                  setFilterByLocationId={setFilterByLocationId}
                  setEndingSoon={setEndingSoon}
                  locations={locations}
                  locationLoading={locationLoading}
                  resetLocationFilter={resetLocationFilter}
                  communities={myIdentities}
                />
              </TemplateSub>
            )}
          </ViewCategoryPWA>
        );
      }}
    </MyAppSettingController>
  );
};
